import {Controller} from "stimulus";

export default class extends Controller {

    static targets = ["step", "result", "options", "title", "progress", "back", "email"]

    data = {
        person: null,
        part: null,
        factor: null,
        form: null
    }

    currentStep = 0;
    chosenTip = null;
    chosenProduct = null;

    connect() {
        this.renderOptions(1, "person")
        this.observeModalVisibility()
    }

    reset() {
        this.data = { person: null, part: null, factor: null, form: null }
        this.currentStep = 0;
        this.renderOptions(1, "person")
        this.resultTarget.innerHTML = "";
        const steps = this.progressTarget.querySelectorAll(".quiz-step");
        steps.forEach((el, index) => {
            el.classList.remove("active");
        });
        steps[0].classList.add("active");

        const steps2 = this.targets.findAll("step")
        steps2.forEach(step => {
            step.classList.remove("hidden")
        })

        steps2[steps2.length - 1].classList.add("hidden");
    }

    products = [
        { person: "Дете", part: "Лице и тяло", factor: "50", form: "Спрей", product: "Solero слънцезащитен спрей за деца SPF50+ 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25249/25249_solero.png.webp", url: "solero-sl-ncezasiten-sprej-za-deca-spf-50-200ml", tip: "Да се избягва обедното слънце!" },
        { person: "Дете", part: "Лице и тяло", factor: "50", form: "Лосион", product: "Solero Лосион за деца за чувствителна кожа SPF50+ 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/27196/27196-solero.png.webp", url: "solero-losion-za-deca-za-chuvstvitelna-kozha-spf50-plus-200ml", tip: "Нанасяйте указаното количество за оптимална защита!" },
        { person: "Възрастен", part: "Лице", factor: "50", form: "Крем", product: "Solero слънцезащитен крем за лице SPF50+ 50мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25247/25247_solero.png.webp", url: "solero-sl-ncezasiten-krem-za-lice-spf50-50ml", tip: "Нанасяйте периодически избрания продукт особено след изпотяване и влизане във водата!" },
        { person: "Възрастен", part: "Лице и тяло", factor: "50", form: "Спрей", product: "Solero хидратиращ слънцезащитен спрей SPF50+ 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25255/25255_solero.png.webp", url: "solero-hidratiras-sl-ncezasiten-sprej-spf50-200ml", tip: "Нанесете продукта на дланите си и внимателно разпределете по лицето като избягвате зоната около очите!"},
        { person: "Възрастен", part: "Лице и тяло", factor: "50", form: "Лосион", product: "Solero Слънцезащитен лосион за чувствителна кожа SPF50+ 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25248/25248_solero.png.webp", url: "solero-sl-ncezasita-za-cyaloto-semejstvo-spf-50-200ml" , tip: "При комбинация с репелент, първо се нанася слънцезащитата и най-рано след 15 мин. репелента!"},
        { person: "Възрастен", part: "Лице и тяло", factor: "30", form: "Спрей", product: "Solero Хидратиращ слънцезащитен спрей SPF30 200мл", image: "https://benu.bg/media/cache/product_view_default/images/products/25251/25251_solero.png.webp", url: "solero-hidrataciya-za-tyalo-s-s-sl-ncezasita-spf-30-200ml", tip: null },
        { person: "Възрастен", part: "Лице и тяло", factor: "30", form: "Лосион", product: "Solero лосион след излагане на слънце с кокос SPF30 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25272/25272_solero.png.webp", url: "solero-sl-ncezasiten-losion-s-kokos-spf30-200ml", tip: null },
        { person: "Възрастен", part: "Лице и тяло", factor: "30", form: "Олио", product: "\tSolero слънцезащитно олио с витамин E SPF30 150мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25273/25273_solero.png.webp", url: "solero-sl-ncezasitno-olio-s-vitamin-e-spf30-150ml", tip: null },
        { person: "Възрастен", part: "Лице и тяло", factor: "15", form: "Спрей", product: "Solero Хидратиращ слънцезащитен спрей SPF15 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25250/25250_solero.png.webp", url: "solero-hidratiras-krem-s-s-sl-ncezasita-spf-15-200ml", tip: null },
        { person: "Цяло семейство", part: "Лице и тяло", factor: "50", form: "Лосион", product: "Solero Слънцезащитен лосион за чувствителна кожа SPF50+ 200мл", image: "https://benu.bg/media/cache/product_view_default_webp/images/products/25248/25248_solero.png.webp", url: "solero-sl-ncezasita-za-cyaloto-semejstvo-spf-50-200ml", tip: null }
    ]

    icons = {
        "Дете": "/build/images/solero/quiz-child-icn.svg",
        "Възрастен": "/build/images/solero/quiz-adults-icn.svg",
        "Цяло семейство": "/build/images/solero/quiz-family-icn.svg",
        "Лице": "/build/images/solero/quiz-face-icn.svg",
        "Лице и тяло": "/build/images/solero/quiz-body-icn.svg",
        "15": "/build/images/solero/quiz-spf-15-icn.svg",
        "30": "/build/images/solero/quiz-spf-30-icn.svg",
        "50": "/build/images/solero/quiz-spf-50-icn.svg",
        "Крем": "/build/images/solero/quiz-cream-icn.svg",
        "Спрей": "/build/images/solero/quiz-spray-icn.svg",
        "Лосион": "/build/images/solero/quiz-lotion-icn.svg",
        "Олио": "/build/images/solero/quiz-oil-icn.svg"
    }

    selectPerson(event) {
        this.data.person = event.currentTarget.dataset.value
        this.renderOptions(2, "part")
    }

    selectPart(event) {
        this.data.part = event.currentTarget.dataset.value
        this.renderOptions(3, "factor")
    }

    selectFactor(event) {
        this.data.factor = event.currentTarget.dataset.value
        this.renderOptions(4, "form")
    }

    selectForm(event) {
        this.data.form = event.currentTarget.dataset.value
        this.showResult()
    }

    updateProgress() {
        const steps = this.progressTarget.querySelectorAll(".quiz-step");
        steps.forEach((el, index) => {
            el.classList.toggle("active", index < this.currentStep);
        });
    }

    previousStep() {
        console.log(this.currentStep)
        if (this.currentStep > 1) {
            this.currentStep -= 1
            console.log(this.currentStep)
            const prevKey = ["person", "part", "factor", "form"][this.currentStep - 1]
            this.renderOptions(this.currentStep, prevKey)
            this.resultTarget.innerHTML = ""
            this.updateProgress()
        }
    }

    observeModalVisibility() {
        const modal = document.getElementById("quizModal")
        if (!modal) return

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "aria-hidden") {
                    const isHidden = modal.getAttribute("aria-hidden") === "true"
                    if (isHidden) {
                        this.modalClosed()
                    }
                }
            })
        })

        observer.observe(modal, { attributes: true })
    }

    modalClosed() {
        this.reset()
    }

    nextStep(stepNumber) {
        const steps = this.targets.findAll("step")
        steps.forEach(step => {
            step.classList.add("hidden")
            if (parseInt(step.dataset.step) === stepNumber) {
                step.classList.remove("hidden")
            }
        })
    }

    showResult() {
        const match = this.products.find(p =>
            p.person === this.data.person &&
            p.part === this.data.part &&
            p.factor === this.data.factor &&
            p.form === this.data.form
        )

        this.chosenTip = match.tip
        this.chosenProduct = match.url
        this.resultTarget.innerHTML = match
            ?   `<img src="${match.image}" alt="">
                   <span> ${match.product} </span> 
                   <br>
                   <a href="/${match.url}" target="_blank" class="btn btn-primary mt-2">ПОРЪЧАЙ сега</a>
                `
            : "<p>Няма продукт за тези филтри.</p>"

        this.nextStep(5)
    }

    selectStep(event) {
        const step = parseInt(event.currentTarget.dataset.step);
        const value = event.currentTarget.dataset.value;

        if (step === 1) this.data.person = value;
        if (step === 2) this.data.part = value;
        if (step === 3) this.data.factor = value;
        if (step === 4) this.data.form = value;

        if (step < 4) {
            this.renderOptions(step + 1, ["person", "part", "factor", "form"][step]);
            this.updateProgress();
        } else {
            this.showResult();
        }
    }

    renderOptions(step, key) {
        const titles = {
            1: "За кого е предназначена слънцезащитата?",
            2: "За коя част?",
            3: "С какъв фактор?",
            4: "Каква форма предпочитате?",
            5: "Резултат"
        };
        if (this.hasTitleTarget) {
            this.titleTarget.textContent = titles[step] || "";
        }
        this.currentStep += 1;

        const options = [...new Set(
            this.products
                .filter(p => {
                    if (step === 2) {
                        return p.person === this.data.person;
                    }

                    if (step === 3) {
                        return p.person === this.data.person && p.part === this.data.part;
                    }

                    if (step === 4) {
                        return p.person === this.data.person &&
                            p.part === this.data.part &&
                            p.factor === this.data.factor;
                    }

                    if (step === 5) {
                        return p.person === this.data.person &&
                            p.part === this.data.part &&
                            p.factor === this.data.factor &&
                            p.form === this.data.form;
                    }

                    return true;
                })
                .map(p => p[key])
        )];

        if (options.length === 0) {
            this.optionsTarget.innerHTML = `<p class="text-gray-500 italic m-2">Няма опции за този избор.</p>`;
            return;
        }

    //     this.optionsTarget.innerHTML = options.map(option => `
    //     <div
    //         class="bg-blue-100 px-4 py-2 rounded m-2 option"
    //         data-action="click->quiz#selectStep"
    //         data-value="${option}"
    //         data-step="${step}">
    //         ${option}
    //     </div>
    // `).join('');

        // Вариант с дефинирана икона
        this.optionsTarget.innerHTML = options.map(option => `
            <div
                class="option"
                data-action="click->quiz#selectStep"
                data-value="${option}"
                data-step="${step}">
                <img src="${this.icons[option] || '/build/images/icons/default.svg'}" alt="${option}" class="option-icn" />
                <span>${option}</span>
            </div>
        `).join('');

        this.backTarget.hidden = this.currentStep === 1;
    }

    submitQuiz(event) {
        event.preventDefault() // stop form from submitting normally

        const email = this.emailTarget.value
        const url = event.currentTarget.dataset.url

        const payload = {
            email: email,
            tip: this.chosenTip,
            productUrl: this.chosenProduct,
        }

        $.ajax({
            url: url,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(payload),
            success: (response) => {
                console.log("Submitted successfully:", response)
                document.getElementById("mailSent").innerHTML = "Проверете вашата поща!"
            },
            error: (xhr, status, error) => {
                console.error("Error submitting quiz:", error)
            }
        })
    }
}
